export var fabricModes = {
    "Spacing": {
        "Default": "default",
        "Compact": "compact",
        "Generous": "generous"
    },
    "Emphasis": {
        "Default": "default",
        "Muted": "muted"
    },
    "Surface": {
        "Surface": "surface",
        "Elevated": "elevated",
        "Base": "base",
        "Section": "section",
        "Inactive": "inactive"
    },
    "Prominence": {
        "Strong": "strong",
        "Subtle": "subtle",
        "Transparent": "transparent"
    },
    "Sentiment": {
        "Primary": "primary",
        "Secondary": "secondary",
        "Tertiary": "tertiary",
        "Neutral": "neutral",
        "Positive": "positive",
        "Negative": "negative",
        "Warning": "warning",
        "Information": "information",
        "Selected": "selected"
    },
    "State": {
        "Default": "default",
        "Hover": "hover",
        "Active": "active"
    }
};
export var Spacings = fabricModes.Spacing;
export var Emphasises = fabricModes.Emphasis;
export var Surfaces = fabricModes.Surface;
export var Prominences = fabricModes.Prominence;
export var Sentiments = fabricModes.Sentiment;
export var States = fabricModes.State;
